// import {Item} from './item';
import "./decor-calc.css";

export const CalcComponent =
{
    data(): object
    {
        return {
            showResult: false,
            hight: '',
            fill: '',
            decor: {}
        }
    },  

    methods: {
        // Начальный расчет итоговой стоимости
        calculation: function() 
        {
            switch(this.hight) {
                case '1':
                    switch(this.fill) {
                        case 'small':
                            this.decor = {
                                'd20': 5,
                                'd15': 5,
                                'd9': 15,
                                'd5': 15,
                                'garland': 'от 30 м.',
                                'accent': 10,
                                'total': 50,
                            }
                            break;
                        case 'middle':
                            this.decor = {
                                'd20': 10,
                                'd15': 10,
                                'd9': 30,
                                'd5': 25,
                                'accent': 15,
                                'garland': 'от 50 м.',
                                'total': 90,
                            }
                            break;
                        case 'big':
                            this.decor = {
                                'd20': 20,
                                'd15': 20,
                                'd9': 40,
                                'd5': 30,
                                'accent': 20,
                                'garland': 'от 100 м.',
                                'total': 130,
                            }
                            break;
                    }
                    break;
                case '2':
                    switch(this.fill) {
                        case 'small':
                            this.decor = {
                                'd20': 15,
                                'd15': 10,
                                'd9': 20,
                                'd5': 20,
                                'accent': 10,
                                'garland': 'от 50 м.',
                                'total': 75,
                            }
                            break;
                        case 'middle':
                            this.decor = {
                                'd20': 20,
                                'd15': 20,
                                'd9': 30,
                                'd5': 30,
                                'accent': 15,
                                'garland': 'от 100 м.',
                                'total': 115,
                            }
                            break;
                        case 'big':
                            this.decor = {
                                'd20': 35,
                                'd15': 30,
                                'd9': 40,
                                'd5': 40,
                                'accent': 30,
                                'garland': 'от 200 м.',
                                'total': 175,
                            }
                            break;
                    }
                    break;
                case '3':
                    switch(this.fill) {
                        case 'small':
                            this.decor = {
                                'd20': 20,
                                'd15': 20,
                                'd9': 30,
                                'd5': 20,
                                'accent': 20,
                                'garland': 'от 100 м.',
                                'total': 110,
                            }
                            break;
                        case 'middle':
                            this.decor = {
                                'd20': 30,
                                'd15': 30,
                                'd9': 40,
                                'd5': 30,
                                'accent': 30,
                                'garland': 'от 200 м.',
                                'total': 160,
                            }
                            break;
                        case 'big':
                            this.decor = {
                                'd20': 40,
                                'd15': 40,
                                'd9': 60,
                                'd5': 40,
                                'accent': 40,
                                'garland': 'от 300 м.',
                                'total': 220,
                            }
                            break;
                    }
                    break;
            }

            this.showResult = true;
        },
        // Модальное окно с заказом коммерческого предложения
        showModal: function() {
            var initialWidth = $('body').width();
            var initialHeight = $('html').height();
            $('body').css({
                'overflow': 'hidden',
                'min-height': initialHeight,
                'width': initialWidth
            });
            $(".overlay").fadeIn(200);
            $(".modal.calculator").fadeIn();
        },
    },

    watch: {
    },

    mounted: function() {
    },

	template: `
        <div class="calc-wrapper row" v-cloak>
            <div class="calc_cont col-lg-7 col-md-12">
                <div class="calc__body">
                    <h2 class="calc__title">Калькулятор расчета украшений на елку</h2>
                    <form action="#" class="calc_form" @submit.prevent="calculation">
                        <div class="calc__row">
                            <div class="calc__line form-line">
                                <span class="label" :class="[hight.length ? 'label-edit' : '', label]">Выбери высоту ели</span>
                                <select name="hight" id="hight" class="input form-control" autocomplete="off" required  v-model="hight">
                                    <option value="" selected="" hidden></option>
                                    <option value="1">1,5 - 1,8м</option>
                                    <option value="2">2,2 - 2,5м</option>
                                    <option value="3">2,7 - 3м</option>
                                </select>
                            </div>
                            <div class="calc__line form-line">
                                <span class="label" :class="[fill.length ? 'label-edit' : '', label]">Какое наполнение хочешь</span>
                                <select name="fill" id="fill" class="input form-control" autocomplete="off" required="" v-model="fill">
                                    <option value="" selected="" hidden></option>
                                    <option value="small">Редко</option>
                                    <option value="middle">Средне</option>
                                    <option value="big">Много</option>
                                </select>
                            </div>
                        </div>
                        <div class="calc__row-last">
                            <div class="calc__line form-line">
                                <button class="btn btn-default" id="calculate" type="submit">Рассчитать</button>
                            </div>
                        </div>
                        <div class="calc__table table-calc" id="calc_result" v-if="showResult">
                            <table>
                                <tbody>
                                    <tr>
                                        <td><div>Шары d 20 см.</div></td>
                                        <td>{{ decor.d20 }}</td>
                                    </tr>
                                    <tr>
                                        <td><div>Шары d 15-20 см.</div></td>
                                        <td>{{ decor.d15 }}</td>
                                    </tr>
                                    <tr>
                                        <td><div>Шары d 9-6 см.</div></td>
                                        <td>{{ decor.d9 }}</td>
                                    </tr>
                                    <tr>
                                        <td><div>Шары d 5 см.</div></td>
                                        <td>{{ decor.d5 }}</td>
                                    </tr>
                                    <tr>
                                        <td><div>Акцентные игрушки разных форм</div></td>
                                        <td>{{ decor.accent }}</td>
                                    </tr>
                                    <tr>
                                        <td><div><b>Гирлянда, м.</b></div></td>
                                        <td>{{ decor.garland }}</td>
                                    </tr>
                                    <tr>
                                        <td><div>Всего игрушек</div></td>
                                        <td><b>{{ decor.total }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </form>
                </div>

            </div>
        </div>
	`,

}
